import RenderAuthorize from '@/components/framework/Authorized'
import { getAuthority } from './index'

let Authorized = RenderAuthorize(getAuthority())

// Reload the rights component
const reloadAuthorized = (): void => {
  Authorized = RenderAuthorize(getAuthority())
}


/**
 * hard code
 * block need it。
 */
// @ts-ignore
window.reloadAuthorized = reloadAuthorized

export { reloadAuthorized }
export default Authorized
